module.exports = __webpack_public_path__ + "img/gszz4@2x.98ef45e1.png";